<template>
    <div class="c-multi-type-product-summary">
        <b-card no-body>
            <div slot="header">
                {{Core.Definition.getDefinition('Produits')}}
                <div class="card-header-actions pull-right">
                    <b-link href="#"  @click="open" class="card-header-action btn-setting pull-right">
                        <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Produit')}}
                    </b-link>
                </div>
            </div>
            <b-card-body>
                <b-row v-for="product, productIndex in dataProducts">
                    <b-col>
                        <table class="table">
                            <td width="40px">
                                <b-btn v-b-toggle="'collapse' + productIndex" class="btn btn-sm btn-light pull-right"><i class="fa fa-chevron-down"></i></b-btn>
                            </td>
                            <td>
                                {{product.instance.title}}<br/>
                                <small>{{product.instance.type}}</small>
                            </td>
                            <td width="160px">
                                <div class="pull-right">
                                    <InputQuantity
                                            v-if="product.instance.type === Core.Product.typeLimitedSubscription"
                                            :step="parseInt(product.instance.bookingLimit)"
                                            @change="eval"
                                            :description="Core.Definition.getDefinition('Place(s)')"
                                            v-model="dataProducts[productIndex].quantity">
                                    </InputQuantity>
                                    <InputQuantity
                                            v-if="product.instance.type === Core.Product.typeStandard"
                                            @change="eval"
                                            v-model="dataProducts[productIndex].quantity">
                                    </InputQuantity>
                                </div>
                            </td>
                            <td width="140px">
                                <InputCurrency
                                        v-if="product.instance.type !== Core.Product.typeRecurringSubscription"
                                        @change="eval"
                                        v-model="dataProducts[productIndex].instance.regularPrice">
                                </InputCurrency>
                            </td>
                            <td width="140px">
                                <label
                                        v-if="product.instance.type !== Core.Product.typeRecurringSubscription">
                                    {{Core.Currency.format(dataProducts[productIndex].total)}}
                                </label>
                            </td>
                            <td width="140px">
                                <div v-if="product.instance.type !== Core.Product.typeRecurringSubscription">
                                    <div v-if="product.isTaxable">
                                        + {{Core.Currency.format(dataProducts[productIndex].taxesTotal)}}
                                        <p class="small" v-html="Core.Taxes.display(dataProducts[productIndex].taxes, true, '<br>')"></p>
                                    </div>
                                    <p v-else class="small">{{Core.Definition.getDefinition('Non taxable')}}</p>
                                </div>
                            </td>
                            <td width="40px">
                                <b-button @click="onTrashClick(productIndex)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></b-button>
                            </td>
                        </table>

                        <b-collapse :id="'collapse' + productIndex" class="mt-2">

                            <b-row>
                                <b-col>
                                    <div v-if="product.instance.description !== '' && product.instance.description !== undefined" v-html="product.instance.description">
                                    </div>
                                    <div v-else-if="product.instance.shortDescription !== '' && product.instance.shortDescription !== undefined">
                                        {{product.instance.shortDescription}}
                                    </div>
                                </b-col>
                            </b-row>

                            <div v-if="product.instance.type === Core.Product.typeRecurringSubscription">
                                <b-row>
                                    <b-col lg="6" md="6" sm="12">
                                        <ProductRecurringSubscriptionSummary
                                                v-model="dataProducts[productIndex].instance"
                                                :onEvalPayments="onEvalPayments"
                                                :caption="Core.Definition.getDefinition('Détails de l\'abonnement')"
                                                :options="{
                                                    displayAddProduct: false,
                                                    displayTitle: false
                                                }">
                                        </ProductRecurringSubscriptionSummary>
                                    </b-col>
                                    <b-col lg="6" md="6" sm="12">
                                        <BookingSummary
                                                v-if="dataProducts[productIndex].instance.bookingLimitManagement"
                                                :ref="'bookingSummary' + productIndex">
                                        </BookingSummary>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-card>
                                            <div slot="header">
                                                {{Core.Definition.getDefinition('Sommaire des paiements')}}
                                            </div>
                                            <List
                                                    :ref="'listPayments' + productIndex"
                                                    :actions="[
                                                            {
                                                                columnLabel: '',
                                                                key: 'editPayment',
                                                                columnClasses: '',
                                                                columnStyles: 'width:20px',
                                                                value: '<button type=\'button\' class=\'btn btn-edit btn-sm\'><i class=\'fa fa-edit\'></i></button>',
                                                                callBack: _self.onEditClick
                                                            },
                                                            {
                                                                columnLabel: '',
                                                                key: 'checkPayment',
                                                                columnClasses: '',
                                                                columnStyles: 'width:20px',
                                                                value: '<button type=\'button\' class=\'btn-check-payment btn btn-light btn-sm\'><i class=\'fa fa-check\'></i></button>',
                                                                callBack: _self.onCheckPaymentClick
                                                            }
                                                    ]"
                                                    :options="{
                                                        emptyText: Core.Definition.getDefinition('Aucun paiement à venir'),
                                                        pagination: false,
                                                        header: true,
                                                        responsive: false,
                                                        striped: true
                                                    }"
                                                    :selectOptions="{
                                                        status: Core.Payment.statusOptions(),
                                                        method: Core.Payment.methodOptions()
                                                    }"
                                                    :columns="[
                                                        {
                                                            label: Core.Definition.getDefinition('Date'),
                                                            key: 'date',
                                                            type: Core.Value.typeDate
                                                        },
                                                        {
                                                            label: Core.Definition.getDefinition('État'),
                                                            key: 'status',
                                                            type: Core.Value.typeSelect
                                                        },
                                                        {
                                                            label: Core.Definition.getDefinition('Méthode'),
                                                            key: 'method',
                                                            type: Core.Value.typeSelect
                                                        },
                                                        {
                                                            label: Core.Definition.getDefinition('Montant'),
                                                            key: 'amount',
                                                            type: Core.Value.typeCurrency
                                                        },
                                                        {
                                                            label: Core.Definition.getDefinition('Taxes'),
                                                            key: 'taxes',
                                                            type: Core.Value.typeCurrency
                                                        },
                                                        {
                                                            label: Core.Definition.getDefinition('Total'),
                                                            key: 'total',
                                                            type: Core.Value.typeCurrency
                                                        },
                                                        {
                                                            label: Core.Definition.getDefinition('# référence'),
                                                            key: 'referenceNumber',
                                                            type: Core.Value.typeText
                                                        }
                                                    ]"
                                                    :rows="dataPayments">
                                            </List>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </div>

                            <div v-if="product.instance.type === Core.Product.typeLimitedSubscription">
                                <b-row>
                                    <b-col>
                                        <BookingSummary
                                                :ref="'bookingSummary' + productIndex">
                                        </BookingSummary>
                                    </b-col>
                                </b-row>
                            </div>

                        </b-collapse>

                    </b-col>
                </b-row>

                <ModalInstanceSelector
                        ref="modalInstanceSelector"
                        root="/product/list"
                        v-model="dataProducts"
                        quantityStep="bookingLimit"
                        :multiple="true"
                        :searchArgs="[
                            {
                                key: 'type',
                                value: [Core.Product.typeLimitedSubscription, Core.Product.typeStandard, Core.Product.typeRecurringSubscription]
                            }
                        ]"
                        :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucun produit à afficher'),
                                borderVariant: 'white',
                                noBody: true
                         }"
                        :columns="[
                                {
                                    label: Core.Definition.getDefinition('#'),
                                    key: 'id',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Type'),
                                    key: 'type',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Prix régulier'),
                                    key: 'Readable.regularPrice',
                                    type: 'text',
                                    sortable: true
                                }
                         ]"></ModalInstanceSelector>
            </b-card-body>
        </b-card>

        <b-modal :title="Core.Definition.getDefinition('Modification du paiement')" class="modal-info"
                 v-model="dataEditModal.show" @ok="saveEdit" :ok-title="Core.Definition.getDefinition('Ok')"
                 ok-variant="edit" :cancel-title="Core.Definition.getDefinition('Annuler')"
                 cancel-variant="light">
            <b-row>
                <b-col lg="12" sm="12">
                    <Alert :alert="{ variant: 'warning', show: Core.Value.encode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC, message: Core.Definition.getDefinition('La modification du paiement est limité, puisque celui-ci à été effectué par carte de crédit.') }"></Alert>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col lg="6" md="6" sm="12">
                    <InputDate
                            :ref="id + '_editDate'"
                            :id="id + '_editDate'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :label="Core.Definition.getDefinition('Date')"
                            v-model="dataEditModal.payment.date"></InputDate>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <InputText
                            :ref="id + '_editReferenceNumber'"
                            :id="id + '_editReferenceNumber'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :label="Core.Definition.getDefinition('# référence')"
                            v-model="dataEditModal.payment.referenceNumber"></InputText>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col lg="6" md="6" sm="12">
                    <InputCurrency
                            :ref="id + '_editAmount'"
                            :id="id + '_editAmount'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :label="Core.Definition.getDefinition('Montant')"
                            v-model="dataEditModal.payment.amount"></InputCurrency>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <InputSelect
                            :ref="id + '_editMethod'"
                            :id="id + '_editMethod'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :options="Core.Payment.methodOptions()"
                            :label="Core.Definition.getDefinition('Méthode')"
                            v-model="dataEditModal.payment.method"></InputSelect>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col lg="7" md="7" sm="12">
                    <InputSelect
                            :ref="id + '_editStatus'"
                            :id="id + '_editStatus'"
                            :readOnly="Core.Value.decode(dataEditModal.payment.method, 'select') === Core.Payment.methodCC && dataEditModal.payment.status === Core.Payment.statusCompleted"
                            :description="Core.Definition.getDefinition('L\'état remboursé ou annulé est à titre indicatif. Aucun remboursement sera effectué à l\'acheteur.')"
                            :options="Core.Payment.statusOptions([
                                     Core.Payment.statusWaiting,
                                     Core.Payment.statusCancelled,
                                     Core.Payment.statusFailed,
                                     Core.Payment.statusRefunded])"
                            :label="Core.Definition.getDefinition('État du paiement')"
                            v-model="dataEditModal.payment.status"></InputSelect>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    var _self = null
    import Alert from './Alert'
    import InputCurrency from './InputCurrency'
    import InputQuantity from './InputQuantity'
    import InputSelect from "./InputSelect"
    import InputDate from "./InputDate"
    import InputText from "./InputText"
    import ModalInstanceSelector from './ModalInstanceSelector'
    import BookingSummary from './BookingSummary'
    import ProductRecurringSubscriptionSummary from './ProductRecurringSubscriptionSummary'
    import List from './List'

    export default {
        name: 'ProductMultipleTypeSummary',
        components: {
            Alert,
            InputCurrency,
            InputQuantity,
            InputSelect,
            InputDate,
            InputText,
            ModalInstanceSelector,
            BookingSummary,
            List,
            ProductRecurringSubscriptionSummary
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            caption: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            taxes: {
                type: Array,
                default: function () {
                    return []
                }
            },
            updateTotal: {
                type: Function,
                default: function () {
                    return 0
                }
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataProducts = val
                },
                deep: true
            },
            dataProducts: {
                handler(val) {
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        mounted() {
            _self = this
            this.dataTaxes = this.taxes
            this.dataProducts = Core.Array.newArray(this.value)
        },
        data: () => {
            return {
                Core: window.Core,
                dataProducts: [],
                dataTotal: 0,
                dataSubTotal: 0,
                dataTrashModal: {
                    show: false,
                    index: ''
                },
                dataTaxes: [],
                dataQuantityStep: '',
                dataEditModal: {
                    show: false,
                    payment: {
                        index: 0,
                        date: '',
                        method: '',
                        status: '',
                        referenceNumber: '',
                        amount: 0,
                        isCheckPayment: ''
                    },
                    index: ''
                }
            }
        },
        methods: {
            onTrashClick(productIndex) {
                this.dataProducts.splice(productIndex, 1)
                this.eval()
            },
            onEvalPayments(dates, value, form, fieldRefs) {
                this.dataPayments = []
                for(let dateIndex in dates) {
                    let date = dates[dateIndex]
                    this.dataPayments.push({
                        index: dateIndex,
                        date: date,
                        status: Core.Payment.statusWaiting,
                        method: Core.Payment.methodCC,
                        amount: value.regularPrice,
                        referenceNumber: '',
                        isCheckPayment: false
                    })
                }
            },
            onEditClick(value, cell, row, rowIndex, columnIndex) {
                this.dataEditModal.payment = {
                    index: row.index,
                    isCheckPayment: row.isCheckPayment,
                    date: row.date,
                    method: Core.Value.selectValue(row.method, Core.Payment.methodOptions()),
                    status: Core.Value.selectValue(row.status, Core.Payment.statusOptions([
                        Core.Payment.statusWaiting,
                        Core.Payment.statusCompleted,
                        Core.Payment.statusCancelled,
                        Core.Payment.statusFailed,
                        Core.Payment.statusRefunded,
                    ])),
                    referenceNumber: row.referenceNumber,
                    amount: row.amount,
                }
                this.dataEditModal.show = true
            },
            onCheckPaymentClick(value, cell, row, rowIndex, columnIndex, component) {
                if (this.dataPayments[rowIndex].isCheckPayment === false) {
                    cell.value = '<button type=\'button\' class=\'btn btn-success btn-sm\'><i class=\'fa fa-check\'></i></button>'
                    this.dataPayments[rowIndex].isCheckPayment = true
                } else {
                    cell.value = '<button type=\'button\' class=\'btn btn-light btn-sm\'><i class=\'fa fa-check\'></i></button>'
                    this.dataPayments[rowIndex].isCheckPayment = false
                }
                component.$forceUpdate()
            },
            saveEdit() {
                let payment = this.dataEditModal.payment
                this.dataPayments[payment.index].isCheckPayment = payment.isCheckPayment
                this.dataPayments[payment.index].referenceNumber = payment.referenceNumber
                this.dataPayments[payment.index].Readable_referenceNumber = payment.referenceNumber
                this.dataPayments[payment.index].amount = payment.amount
                this.dataPayments[payment.index].Readable_amount = Core.Currency.format(payment.amount)
                this.dataPayments[payment.index].date = payment.date
                this.dataPayments[payment.index].Readable_date = Core.Date.readableDate(payment.date)
                this.dataPayments[payment.index].method = Core.Value.decode(payment.method, Core.Value.typeSelect)
                this.dataPayments[payment.index].Readable_method = Core.Select.label(payment.method)
                this.dataPayments[payment.index].status = Core.Value.decode(payment.status, Core.Value.typeSelect)
                this.dataPayments[payment.index].Readable_status = Core.Select.label(payment.status)
                this.eval()
            },
            eval() {
                this.dataSubTotal = 0
                this.dataTotal = 0

                let taxes = []

                for(let productIndex in this.dataProducts) {

                    if (this.$refs['bookingSummary' + productIndex] !== undefined) {
                        if (this.dataProducts[productIndex].instance.type === Core.Product.typeLimitedSubscription) {
                            this.$refs['bookingSummary' + productIndex][0].dataBookingLimit = this.dataProducts[productIndex].quantity
                        }
                        if (this.dataProducts[productIndex].instance.type === Core.Product.typeRecurringSubscription) {
                            this.$refs['bookingSummary' + productIndex][0].dataBookingLimit = this.dataProducts[productIndex].instance.bookingLimit
                        }
                    }

                    this.dataQuantityStep = 'bookingLimit'
                    if (isNaN(this.dataQuantityStep)) {
                        if (this.dataProducts[productIndex].instance[this.dataQuantityStep] !== undefined && !isNaN(this.dataProducts[productIndex].instance[this.dataQuantityStep]) && this.dataProducts[productIndex].instance[this.dataQuantityStep] > 0) {
                            this.dataQuantityStep = this.dataProducts[productIndex].instance[this.dataQuantityStep]
                        } else {
                            this.dataQuantityStep = 1
                        }
                    } else {
                        this.dataQuantityStep = 1
                    }

                    if (this.dataProducts[productIndex].instance.regularPrice !== undefined) {
                        if (this.dataProducts[productIndex].taxes === undefined||this.dataProducts[productIndex].taxes.length===0) {
                            this.dataProducts[productIndex].taxes = this.dataTaxes
                        }
                        if (this.dataProducts[productIndex].quantity!==undefined) {

                            if (isNaN(this.dataProducts[productIndex].quantity) && this.dataProducts[productIndex].quantity == 0) {
                                this.dataProducts[productIndex].quantity = this.dataQuantityStep
                            }

                            let subTotal = (this.dataProducts[productIndex].instance.regularPrice * this.dataProducts[productIndex].quantity) / this.dataQuantityStep

                            let taxesTotal = 0
                            if (this.dataProducts[productIndex].isTaxable!==undefined&&this.dataProducts[productIndex].isTaxable == true) {
                                for(let productTaxIndex in this.dataProducts[productIndex].taxes) {
                                    let productTax = this.dataProducts[productIndex].taxes[productTaxIndex]
                                    productTax.total = Core.Taxes.total(subTotal, productTax)
                                    this.dataProducts[productIndex].taxes[productTaxIndex] = productTax

                                    let taxIndex = Core.Array.findIndexByKey(taxes, 'label', productTax.label)
                                    if (taxIndex===false) {
                                        taxes.push(productTax)
                                    } else {
                                        taxes[taxIndex].total = taxes[taxIndex].total + productTax.total
                                    }
                                    taxesTotal += productTax.total
                                }
                            }

                            let total = subTotal + taxesTotal

                            this.dataSubTotal += subTotal
                            this.dataTotal += total

                            this.dataProducts[productIndex].taxesTotal = taxesTotal
                            this.dataProducts[productIndex].total = subTotal

                            this.dataTaxes = taxes
                        }
                    }
                }
                this.$emit('updateTotal', this.dataSubTotal, this.dataTotal, this.form, this.fieldRefs)
            },
            open() {
                this.$refs.modalInstanceSelector.open = true
            }
        }
    }
</script>
